module.exports = __webpack_public_path__ + "media/images/proof_links/colored/netflix-27562aea7cd66cbaa593a02b86f257b8.svg";